import revive_payload_client_4sVQNw7RlN from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/buildhome/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/buildhome/repo/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/buildhome/repo/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_t2GMTTFnMT from "/opt/buildhome/repo/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import slideovers_LDumGYo2KH from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.mjs";
import modals_bidRKewKK5 from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/plugins/modals.mjs";
import colors_244lXBzhnM from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_OVoKJro5pc from "/opt/buildhome/repo/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_uNcnkSEldr from "/opt/buildhome/repo/node_modules/nuxt-icon/dist/runtime/plugin.js";
import plugin_PSbK9A48ZQ from "/opt/buildhome/repo/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import auth_init_client_samVUQJ6qd from "/opt/buildhome/repo/plugins/auth-init.client.js";
import dark_mode_client_pbsSMiJAif from "/opt/buildhome/repo/plugins/dark-mode.client.js";
import mainState_wd8zZxoShp from "/opt/buildhome/repo/plugins/mainState.js";
import slugify_client_bi4ee7jQjn from "/opt/buildhome/repo/plugins/slugify.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_t2GMTTFnMT,
  slideovers_LDumGYo2KH,
  modals_bidRKewKK5,
  colors_244lXBzhnM,
  plugin_client_OVoKJro5pc,
  plugin_uNcnkSEldr,
  plugin_PSbK9A48ZQ,
  auth_init_client_samVUQJ6qd,
  dark_mode_client_pbsSMiJAif,
  mainState_wd8zZxoShp,
  slugify_client_bi4ee7jQjn
]